import React from "react";
import FeedbackForm from "@/components/FeedbackForm";
import { LifeBuoy } from "lucide-react";

export default function Support() {
  return (
    <FeedbackForm
      kind="support"
      title="Support"
      subtitle="Wir helfen dir bei jedem Problem — werktags innerhalb von 4 Stunden"
      hero={{
        icon: LifeBuoy,
        title: "Support",
        headline: "Du brauchst Hilfe? Wir sind für dich da.",
        description: "Beschreibe dein Anliegen unten. Unsere Experten antworten innerhalb von 4 Stunden während der Geschäftszeiten (Mo–Fr 9–18 Uhr).",
        gradient: "from-cyan-500 to-blue-600",
      }}
      topics={["Login funktioniert nicht", "PDF-Export schlägt fehl", "Foto-Upload langsam", "Frage zur Abrechnung", "Rolle / Rechte ändern"]}
      emptyState="Du hast noch keine Support-Anfrage gestellt."
      testidPrefix="support"
    />
  );
}
